import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Timer Sand"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-timer-sand',
    templateUrl: './icon-timer-sand.component.html',
    styleUrls: ['./icon-timer-sand.component.scss'],
    standalone: false
})
export class IconTimerSandComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
